import { SharedLanguageService } from '@language';

export const TranslateOrDefault = (
    translateService: SharedLanguageService,
    query: string,
    defaultValue?: string,
    ...args: string[]
): string => {
    const translated: string = translateService.instant(query, args);

    if (translated === query || typeof translated !== 'string') {
        return defaultValue ? translateService.instant(defaultValue) : '';
    }

    return translated;
};
